module.exports = __webpack_public_path__ + "static/media/BentonSansCond-Bold.6f6753fd.otf";